// External libraries
import gql from 'graphql-tag';

// TODO: GenericAddress fields deprecated in favor of portable addresses
// see: https://github.paypal.com/Checkout-R/xobuyernodeserv/pull/2746
/* eslint graphql/no-deprecated-fields: off */

export const ADDRESS_FROM_AUTOCOMPLETE_PLACE_ID_QUERY = gql`
  query AddressFromAutocompletePlaceIdQuery(
    $language: CheckoutContentLanguageCode
    $placeId: ID!
    $sessionId: String!
  ) {
    addressFromAutoCompletePlaceId(
      language: $language
      placeId: $placeId
      sessionId: $sessionId
    ) {
      address {
        line1
        line2
        city
        state
        postalCode
        country
      }
    }
  }
`;
